import css from './backPane.module.scss';

import cx from 'classnames';
import { memo } from 'react';

import { TWordCardSide } from '../shared';
import useFlipWordCardAnimation, { AmimationStep } from './useFlipAnimation';
import useSidesDetect from './useSidesDetect';

type TProps = {
  deck: TDeck;
  word: TWord;
  setSide: (side: TWordCardSide) => void;
  side: TWordCardSide;
  setIsAnimating: (val: boolean) => void;
  disabled: boolean;
  exercise: keyof Pick<TExerciseEnum, 'wordCards' | 'wordCardsReverse'>;
  className?: string;
};

const BackWordPane: React.FC<TProps> = ({
  deck,
  word,
  side,
  setSide,
  setIsAnimating,
  disabled,
  exercise,
  className = '',
}) => {
  const [animationStep, flip] = useFlipWordCardAnimation(
    side,
    setSide,
    setIsAnimating
  );
  const isAnimating = animationStep !== AmimationStep.NONE;

  const { frontPanel, backPanel } = useSidesDetect({
    deck,
    exercise,
    flip,
    side,
    word,
    disabled: isAnimating || disabled,
  });

  return (
    <div
      className={cx(css.container, className)}
      data-flip-step={animationStep}
    >
      <div
        className={css.wrapper}
        // important: reacreate domnode after finishing each animation
        key={side}
      >
        <div className={css.flipfront}>{frontPanel}</div>
        {backPanel && <div className={css.flipback}>{backPanel}</div>}
      </div>
    </div>
  );
};

export default memo(BackWordPane);
